import { initializeApp, FirebaseApp } from 'firebase/app';
import { getMessaging, Messaging } from 'firebase/messaging';

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const vapidKey: string | undefined = import.meta.env
  .VITE_FIREBASE_VAPID_KEY;

const isConfigured =
  config.apiKey && config.projectId && config.messagingSenderId && config.appId;

const app: FirebaseApp | null = isConfigured ? initializeApp(config) : null;

export function getMessagingInstance(): Messaging | null {
  if (!app) return null;
  try {
    return getMessaging(app);
  } catch {
    return null;
  }
}
